import { render, staticRenderFns } from "./quickTraineeReg.vue?vue&type=template&id=421638bc&scoped=true"
import script from "./quickTraineeReg.vue?vue&type=script&lang=js"
export * from "./quickTraineeReg.vue?vue&type=script&lang=js"
import style0 from "./quickTraineeReg.vue?vue&type=style&index=0&id=421638bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421638bc",
  null
  
)

export default component.exports